import template from './location_zone.edit.html';
import controller from './location_zone.edit.controller';
import './location_zone.edit.scss';

const locationZoneEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationZoneEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/edit/location_zone.edit.component.js